import { useContext } from 'react';
import { AccountContext } from '../context/AccountContext';

export function useActiveAccountOptional() {
  return useContext(AccountContext);
}

export default function useActiveAccount() {
  const ctx = useContext(AccountContext);
  if (!ctx) throw new Error('useActiveAccount must be used within AccountProvider');
  return ctx;
}
